import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { JwtService } from 'src/auth/services/jwt.service';
import { CertRedirectorService } from './cert-redirector.service';

export const certLandingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const jwtService = inject(JwtService);
  const certRedirector = inject(CertRedirectorService);

  return jwtService.allowedPortals$.pipe(
    map((allowedPortals) => {
      const isAllowed = allowedPortals.some((x) => x.trim().toLowerCase() === 'cert');
      if (!isAllowed) {
        return router.createUrlTree(['/launch']);
      }
      const target = certRedirector.redirectUser();
      return typeof target === 'string' ? router.parseUrl('/' + target) : target;
    }),
  );
};
